import {observer, React} from '@api'
import {MenuItem, MenuItemProps} from '@blueprintjs/core'

export const WhiteboardMenuItem = observer<MenuItemProps & {kbd?: string}>(function WhiteboardMenuItem({kbd, ...props}) {
  return (<MenuItem {...props} />)
})


// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/WhiteboardMenuItem.tsx